import type { PartnerConfig } from "@/content/partners/types"

export const IBH_PARTNER_SLUG = "ibh"

export const IBH_LOGO_PATH = "/partners/ibh/logo.png"

/** Marca IBH só em kicker/anel do logo — CTAs continuam Action-Blue da Astra. */
export const ibhBrand = {
  accent: "#9C3133",
  accentLight: "#E8A8A9",
  ringFrom: "#9C3133",
  ringTo: "#6B1F21",
} as const

export const ibhPartnerConfig: PartnerConfig = {
  slug: IBH_PARTNER_SLUG,
  name: "IBH Imóveis",
  fullName: "IBH Imóveis",
  logoPath: IBH_LOGO_PATH,
  benefitMode: "none",
  isActive: true,
  partnershipMention: "Parceria IBH Imóveis",
  metadata: {
    website: "https://www.ibhimoveis.com.br/",
    industry: "imobiliaria",
  },
}

export const ibhPartnerContent = {
  ...ibhPartnerConfig,
  heroSubtitle: "Sem obras. Sem instalação. Conecte-se a uma usina solar.",
} as const
